import React, { Fragment, useEffect, useMemo, useState } from "react";
import { ISections } from "types/ISections";
import SectionV2 from "components/Sections/SectionV2";
import Skeleton from "components/Skeleton/Skeleton";
import useWindowSize from "hooks/useWindowSize";
import { IFinalEvent, ShortsVideo } from "types/event";
import DateFilterationSkeleton from "components/Skeleton/EventsDateFilterationComponentSkeleton";
import { useLang } from "hooks/useLang";

interface EventsSectionsProps {
  sectionsData: ISections[];
  videos_sections?: ISections[];
  filteredEvents: IFinalEvent[];
  isLoading: boolean;
  initialIsMobile?: boolean;
}

const EventsSections: React.FC<EventsSectionsProps> = ({
  sectionsData,
  videos_sections,
  filteredEvents,
  isLoading,
  initialIsMobile = false,
}) => {
  const { isMobile } = useWindowSize();
  const { multiLangVars } = useLang();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const effectiveIsMobile = hasMounted ? isMobile : initialIsMobile;

  const visibleSections = useMemo(
    () =>
      sectionsData
        ?.map((section: ISections) => ({
          section,
          sectionEvents: filteredEvents.filter(
            (event) =>
              event._id &&
              section.events?.some((sectionEvent) => sectionEvent._id === event._id)
          ),
        }))
        .filter(
          ({ sectionEvents, section }) =>
            sectionEvents.length > 0 || (section.videos?.length ?? 0) > 0
        ) ?? [],
    [sectionsData, filteredEvents]
  );

  if (isLoading) {
    return (
      <>
        <div className="mt-24 layout">
          <DateFilterationSkeleton />
        </div>

        <div className="layout flex flex-col gap-4 mt-4">
          <Skeleton
            className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
            title
            type="event_card"
          />
          <Skeleton className="" title type="event_card" />
        </div>
      </>
    );
  }

  return (
    <>
      {/* {videos_sections.length > 0 &&
        videos_sections.map((section) => (
          <Fragment key={section._id}>
            <SectionV2
              id={section._id}
              events={[]}
              videos={section.videos}
              className=""
              title={
                section?.[multiLangVars("title") as "en_title" | "ar_title"]
              }
              type={section.type}
              maxEventsInARow={section.max_row_events}
              layout={isMobile ? section.mobile_layout : section.layout}
              aspectRatio={section.aspect_ratio}
            />
          </Fragment>
        ))} */}
      <div>
        {visibleSections.map(({ section, sectionEvents }) => (
          <Fragment key={section._id}>
            <SectionV2
              id={section._id}
              events={sectionEvents}
              videos={section.videos}
              className=""
              title={
                section?.[multiLangVars("title") as "en_title" | "ar_title"]
              }
              // type={section.type}
              maxEventsInARow={section.max_row_events}
              layout={effectiveIsMobile ? section.mobile_layout : section.layout}
              aspectRatio={section.aspect_ratio}
              initialIsMobile={initialIsMobile}
            />
          </Fragment>
        ))}
      </div>
    </>
  );
};

export default EventsSections;
